import { ProducerUserTypesEnumSchema } from '@eigtech/auth0-types';
import { z } from 'zod';
import { PortalConsumerInSchema, PortalEntityTypeSchema, StagedPortalConsumerInSchema, } from '../../base/portal.js';
import { PortalZoneSchema } from '../../base/zones.js';
export const ActivatePortalRequestBodySchema = z.object({
    auth0Id: z.string().optional(),
    email: z.string().optional(),
    entityId: z.string(),
    entityPermissions: z.array(z.string()),
    entityType: PortalEntityTypeSchema,
    externalUserId: z.string(),
    name: z.string().optional(),
    phoneNumber: z.string().optional(),
    requestActor: z.string(),
    userType: ProducerUserTypesEnumSchema,
    zone: PortalZoneSchema,
});
export const ActivatePortalRequestSchema = ActivatePortalRequestBodySchema;
export const ActivatePortalResponseSchema = z.object({
    portal: PortalConsumerInSchema.or(StagedPortalConsumerInSchema).or(z.null()),
});
export const ActivatePortalApiSchema = {
    body: ActivatePortalRequestBodySchema,
    response: ActivatePortalResponseSchema,
};
